/** FE permission interceptor tarafından üretilen 403 yanıtı işareti */
export const CLIENT_PERMISSION_DENIED_FLAG = 'permissionDeniedByClient';

export function isClientPermissionDenied(error: unknown): boolean {
  if (!error || typeof error !== 'object') {
    return false;
  }
  const err = error as { error?: Record<string, unknown>; status?: number };
  return (
    err.status === 403 &&
    err.error?.[CLIENT_PERMISSION_DENIED_FLAG] === true
  );
}
